import { buildTypedMap } from '../types/TypedMap';
import { List } from 'immutable';
import { FETCH_PORTAL_CONFIG_SUCCEEDED, FETCH_PORTAL_WIDE_CADENCE_SUCCEEDED, FETCH_PIPELINES_SUCCEEDED, FETCH_FORECAST_TYPES_STARTED, FETCH_FORECAST_TYPES_SUCCEEDED, FETCH_FORECAST_TYPES_FAILED, FETCH_REP_DEAL_COLUMNS_STARTED, FETCH_REP_DEAL_COLUMNS_SUCCEEDED, FETCH_REP_DEAL_COLUMNS_FAILED, UPDATE_REP_DEAL_COLUMNS } from '../actions/ActionTypes';
import { FAILED, STARTED, SUCCEEDED, UNINITIALIZED } from '../constants/RequestStatusTypes';
import { ForecastAmountSettingOptions } from '../constants/PortalConfigConstants';
export const initialState = buildTypedMap({
  pipelines: List(),
  portalConfig: ForecastAmountSettingOptions.TOTAL_AMOUNT,
  portalWideCadence: null,
  forecastTypesStatus: UNINITIALIZED,
  forecastTypes: [],
  repDealColumnsStatus: UNINITIALIZED,
  repDealColumns: []
});
export default function forecast(state = initialState, action) {
  switch (action.type) {
    case FETCH_PORTAL_CONFIG_SUCCEEDED:
      {
        const {
          payload
        } = action;
        return state.merge({
          portalConfig: payload
        });
      }
    case FETCH_PORTAL_WIDE_CADENCE_SUCCEEDED:
      {
        const {
          payload
        } = action;
        return state.merge({
          portalWideCadence: payload
        });
      }
    case FETCH_PIPELINES_SUCCEEDED:
      {
        const {
          payload
        } = action;
        return state.merge({
          pipelines: payload
        });
      }
    case FETCH_FORECAST_TYPES_STARTED:
      return state.merge({
        forecastTypesStatus: STARTED
      });
    case FETCH_FORECAST_TYPES_SUCCEEDED:
      {
        const {
          payload
        } = action;
        return state.merge({
          forecastTypesStatus: SUCCEEDED
        }).set('forecastTypes', payload);
      }
    case FETCH_FORECAST_TYPES_FAILED:
      {
        return state.merge({
          forecastTypesStatus: FAILED
        });
      }
    case FETCH_REP_DEAL_COLUMNS_STARTED:
      return state.merge({
        repDealColumnsStatus: STARTED
      });
    case FETCH_REP_DEAL_COLUMNS_SUCCEEDED:
      {
        const {
          payload
        } = action;
        return state.merge({
          repDealColumnsStatus: SUCCEEDED
        }).set('repDealColumns', payload);
      }
    case FETCH_REP_DEAL_COLUMNS_FAILED:
      {
        return state.merge({
          repDealColumnsStatus: FAILED
        });
      }
    case UPDATE_REP_DEAL_COLUMNS:
      {
        const {
          payload
        } = action;
        const existingColumns = state.get('repDealColumns');
        const updatedColumns = existingColumns.map(columns => {
          if (columns.forecastTypeId === payload.forecastTypeId) {
            return Object.assign({}, columns, {
              dealColumns: payload.dealColumns
            });
          } else {
            return columns;
          }
        });
        return state.set('repDealColumns', updatedColumns);
      }
    default:
      return state;
  }
}